export default __webpack_public_path__ + "static/media/bianca-peres.92af1f22.jpg";